export default {
  placeholder: '請輸入訊息...',
  backToBottom: '回到底部',
  clearCurrentDialogue: '清除當前對話',
  clearDialogue: '清除對話',
  clearModalTitle: '您即將清除會話，清除後將無法恢復。您確定要清除當前會話嗎？',
  defaultHelloMessage: '讓我們開始聊天吧',
  cancel: '取消',
  confirm: '確認',
  copy: '複製',
  copySuccess: '複製成功',
  delete: '刪除',
  edit: '編輯',
  history: '歷史',
  regenerate: '重新生成'
};